import React, { useState } from 'react'
import flagId from "@/assets/flag_id.svg"
import flagUs from "@/assets/flag_us.svg"
import Image from 'next/image'
import { montserratMedium, montserratNormal } from '@/assets/fonts/montserrat'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useRouter } from 'next/router'
export default function SecondFooter({text, selectedLang = "id", changeLang, link}) {
  const [open, setOpen] = useState(false)
  const router = useRouter()
  return (
    <div className='flex px-8 flex-col w-full h-full'>
        <div className='flex w-full justify-between items-center'>
            <div className={`${montserratNormal.className} hover:cursor-pointer flex`} onClick={() => router.push(link)}>{text}</div>
            {/* <div className='flex rounded-md relative border-[2px] border-gray-cool-300 justify-center items-center p-2'>
                {
                    selectedLang == "id" ? (
                        <div onClick={() => setOpen(prev => !prev)} className='flex hover:cursor-pointer items-center w-full'>
                           <div className='w-10'><Image src={flagId} /></div> 
                           <div className={`${montserratMedium.className} flex pr-3`}>Bahasa Indonesia</div>
                           <div className='border-l-[2px] pl-3 pr-1 relative border-gray-cool-300 flex justify-center items-center'>
                            <ChevronDownIcon width={20}/>
                           </div>
                        </div>
                    ) : (
                        <div onClick={() => setOpen(prev => !prev)} className='flex hover:cursor-pointer items-center w-full'>
                           <div className='w-10'><Image src={flagUs} /></div> 
                           <div className={`${montserratMedium.className} flex pr-3`}>English (USA)</div>
                           <div className={`border-l-[2px] pl-3 pr-1 relative border-gray-cool-300 flex justify-center items-center`}>
                            <ChevronDownIcon width={20} className={`${open ? "" : "-rotate-90"}`}/>
                           </div>
                        </div>
                    )
                }
                {
                    open && (
                        <div className='absolute top-12 space-y-2 rounded-lg flex flex-col bg-base-white overflow-hidden w-full border-[2px] border-gray-cool-300'>
                            <div onClick={() => {changeLang(), setOpen(prev => !prev)}} className='w-full px-4 py-4 h-full hover:cursor-pointer hover:bg-gray-cool-100 justify-between items-center flex'>
                                <div className='w-10'><Image src={flagId} /></div> 
                                <div className={`${montserratMedium.className} w-full flex`}>Bahasa Indonesia</div>
                            </div>
                            <div onClick={() => {changeLang(), setOpen(prev => !prev)}} className='w-full px-4 py-4 h-full hover:cursor-pointer hover:bg-gray-cool-100 justify-between items-center flex'>
                                <div className='w-10'><Image src={flagUs} /></div> 
                                <div className={`${montserratMedium.className} w-full flex`}>English (USA)</div>
                            </div>
                        </div>
                    )
                }
            </div> */}
        </div>
        <hr className='border-[1px] my-8 border-gray-cool-200 w-full'/>
        <div className={`${montserratNormal.className} pb-8 flex flex-col justify-center w-full text-center`}>
            <p>© 2024 Ledgerowl All rights reserved.</p>
            <div className='w-full flex justify-center items-center'>
                <p className='w-full lg:w-[60%]'>Ledgerowl provides finance operations services to help small business owners reduce their admin costs using technology. Ledgerowl does not provide services requiring public accountancy license; hence it is not a public accounting firm. Any advice provided on the platform does not constitute financial advice. Accordingly, you should seek professional guidance for your specific situation.</p>
            </div>
        </div>
    </div>
  )
}
